<script setup lang="ts">
import Budweg from '@/assets/logo_budweg.svg?skipsvgo'
import Rodenstock from '@/assets/logo_rodenstock.svg?skipsvgo'
import Electrolux from '@/assets/logo_electrolux.svg?skipsvgo'
import Batna from '@/assets/logo_batna.svg?skipsvgo'
import KGM from '@/assets/logo_kgm.svg?skipsvgo'
import Textar from '@/assets/logo_textar.svg?skipsvgo'
import Shield from '@/assets/shield.svg?skipsvgo'
import CheckIcon from '@/assets/check-circle.svg?skipsvgo'
import Shuffle from '@/assets/shuffle.svg?skipsvgo'
import Smile from '@/assets/smile.svg?skipsvgo'
import Check from '@/assets/icon-check.svg?skipsvgo'

interface Form {
  email: string,
  phone?: string,
  comment: string,
}

const { data: user, status } = useAuth()
const { executeRecaptcha } = useGoogleRecaptcha()
const runtimeConfig = useRuntimeConfig()
const route = useRoute()

const initialState = ref<{ email?: string }>({})

if (status.value === 'authenticated' && user.value) {
  initialState.value.email = user.value.email
}

const submitted = ref(false)

const cdnUrl = `${runtimeConfig.public.cdn}/static/dla-firm`
const brands = [
  { icon: Rodenstock },
  { icon: Budweg },
  { icon: Electrolux },
  { icon: Batna },
  { icon: KGM },
  { icon: Textar }
]
const renaultFormulaCar = [
  { label: 'Przyspieszenie 0-100 km/h', value: '4 sek' },
  { label: 'Prędkość max.', value: '260 km/h' },
  { label: 'Waga bolidu', value: '480 kg' },
  { label: 'Silnik', value: 'RS Renault F4 2000cc' },
  { label: 'Moc', value: '220 KM przy 8000 obr/min' },
  { label: 'Skrzynia', value: '6 biegowa' }
]
const defensiveDrivingTrainings = [
  'Techniki jazdy defensywnej',
  'Jazda w różnych warunkach',
  'Efektywna jazda - techniki eco-drivingu',
  'Pierwsza pomoc przedmedyczna'
]
const williamsFW29 = [
  { label: 'Przyspieszenie 0-200 km/h', value: '5 sek' },
  { label: 'Prędkość max.', value: '350 km/h' },
  { label: 'Waga bolidu', value: '550 kg' },
  { label: 'Silnik', value: 'Cosworth V8' },
  { label: 'Moc', value: '650 KM przy 12000 obr/min' },
  { label: 'Skrzynia', value: '6 biegowa' }
]
const sections = [
  {
    icon: Smile,
    title: 'Doświadczenie i pasja',
    description: 'Jesteśmy zespołem pasjonatów motoryzacji, którzy zorganizowali już setki imprez dla firm. Posiadamy bogate doświadczenie i wiedzę, dzięki czemu możemy zapewnić Ci perfekcyjną organizację eventu.'
  },
  {
    icon: Shuffle,
    title: 'Szeroki wybór możliwości',
    description: 'Poza przejazdami oferujemy szkolenia na symulatorach jazdy, zawody kartingowe, a także wiele innych atrakcji. Możemy dopasować program eventu do Twoich indywidualnych potrzeb i budżetu.'
  },
  {
    icon: Shield,
    title: 'Bezpieczeństwo',
    description: 'Wszystkie nasze eventy odbywają się na zamkniętych dla ruchu ulicznego torach, pod okiem doświadczonych instruktorów. Dbamy o to, aby każdy uczestnik czuł się bezpiecznie i komfortowo.'
  },
  {
    icon: CheckIcon,
    title: 'Dodatkowe usługi',
    description: 'Oferujemy szereg dodatkowych usług, takich jak catering, transport, noclegi, materiał foto-video z imprezy. Przekraczamy Twoje oczekiwania, aby maksymalnie ułatwić Ci organizację eventu firmowego.'
  }
]
const boxes = [
  {
    src: '/dla_firm-box-1.png',
    alt: 'Box 1',
    title: 'Szeroki wybór aut',
    description: 'Uczestnicy Twojego eventu mogą zasiąść za kierownicą takich sław motoryzacji jak Lamborghini, Ferrari, Lotus, Aston Martin, Porsche 911, Mitsubishi Lancer, Nissan GTR, Ariel Atom, KTM X-Bow i wielu innych.'
  },
  {
    src: '/dla_firm-box-2.png',
    alt: 'Box 2',
    title: 'Jazdy z kierowcami rajdowymi',
    description: 'Uczestnicy mogą usiąść na fotelu pasażera i doświadczyć jazdy z prawdziwym profesjonalistą.'
  },
  {
    src: '/dla_firm-box-3.png',
    alt: 'Box 3',
    title: 'Mini-wyścigi samochodowe',
    description: 'Organizujemy zawody polegające na jednoczesnym wyścigu kilku samochodów jednej marki. Wciągająca forma rywalizacji, która integruje pracowników i buduje pozytywne relacje.'
  },
  {
    src: '/dla_firm-box-4.png',
    alt: 'Box 4',
    title: 'Dodatkowe atrakcje',
    description: 'Jazda spalinowymi minisamochodami RC, szkolenie na symulatorach jazdy, jazda z trolejami, ćwiczenie umiejętności wyjścia z poślizgu na matach poślizgowych.'
  },
  {
    src: '/dla_firm-box-5.png',
    alt: 'Box 5',
    title: 'Kompleksowa organizacja',
    description: 'Zajmiemy się wszystkim, od cateringu i noclegu po transport i zapewnienie bezpieczeństwa uczestników.'
  },
  {
    src: '/dla_firm-box-6.png',
    alt: 'Box 6',
    title: 'Najwyższy poziom obsługi',
    description: 'Dbamy o komfort i zadowolenie organizatorów oraz uczestników.'
  },
  {
    src: '/dla_firm-box-7.png',
    alt: 'Box 7',
    title: 'Obecność gwiazd motorsportu',
    description: 'Dodatkowa atrakcja, która z pewnością zrobi wrażenie na uczestnikach.'
  },
  {
    src: '/dla_firm-box-8.png',
    alt: 'Box 8',
    title: 'Niezapomniane emocje',
    description: 'Gwarantujemy, że Twój event firmowy będzie wyjątkowym i niezapomnianym przeżyciem dla wszystkich.'
  }
]
const eventTopics = [
  'Organizacja eventów',
  'Imprezy integracyjne dla firm',
  'Imprezy firmowe',
  'Eventy firmowe',
  'Imprezy integracyjne'
]

const scrollToMainContent = () => {
  const element = document.getElementById('contact')
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' })
  }
}

const submit = async (form: Form, node: any) => {
  const token = await executeRecaptcha('send_email')
  try {
    await $fetch('/send-email', {
      method: 'POST',
      body: { form, token }
    })
    
    submitted.value = true
    node.reset({ email: form.email })
  } catch ({ data: error }) {
    node.setErrors(error.data.errors.map(({ detail }) => detail))
  }
}

useHead({
  titleTemplate: 'Imprezy integracyjne dla firm - %s',
  meta: [
    { name: 'robots', content: 'index,follow' }
  ],
  link: [
    { rel: 'canonical', href: `${runtimeConfig.public.baseUrl}${route.path}` }
  ]
})
</script>

<template>
  <Breadcrumbs :breadcrumbs="[{ name: 'Dla firm' }]" />
  <div class="relative w-full h-screen">
    <video
      ref="video"
      autoplay
      loop
      muted
      playsinline
      class="absolute top-0 left-0 w-full h-full object-cover z-0"
    >
      <source :src="`${cdnUrl}/movie.mp4`" type="video/mp4" media="(min-width: 1920px)">
      <source :src="`${cdnUrl}/movie-720.mp4`" type="video/mp4" media="(min-width: 1280px)">
      <source :src="`${cdnUrl}/movie-480.mp4`" type="video/mp4" media="(min-width: 800px)">
      <source :src="`${cdnUrl}/movie-360.mp4`" type="video/mp4">
    </video>
    <div class="absolute top-0 left-0 w-full h-full bg-black opacity-80" />
    <div class="relative flex flex-col items-center justify-center h-full text-center text-white py-4 px-6 z-10">
      <h1 class="text-24 leading-8 md:text-[30px] md:leading-10 xl:text-[36px] xl:leading-[44px] 2xl:text-[50px] 2xl:leading-[63px] font-bold mb-4">
        Go-Racing <br class="hidden xl:block"><span class="text-red">organizacja eventów</span> dla firm
      </h1>
      <div class="flex flex-col gap-2 w-full xl:w-1/2 2xl:w-1/3 mx-auto">
        <p class="text-16">
          Odkryj świat motoryzacji i poczuj prawdziwą adrenalinę!
        </p>
        <p class="text-16">
          Organizujemy eventy motoryzacyjne dla firm: od ekscytujących przejażdżek bolidem F1, przez jazdę superautami, aż po przygody off-road.
        </p>
        <button
          class="bg-red hover:bg-white text-white hover:text-red font-bold transition-colors duration-200 mx-auto px-8 py-4 mt-4"
          @click="scrollToMainContent"
        >
          Sprawdź ofertę
        </button>
      </div>
    </div>
  </div>
  <div class="w-full bg-red p-2 mb-3 xl:mb-24">
    <div class="grid gap-2 sm:gap-4 grid-cols-3 lg:flex px-2">
      <div
        v-for="(brand, index) in brands"
        :key="index"
        class="mx-auto flex-shrink-0"
      >
        <component :is="brand.icon" class="w-24 h-24" />
      </div>
    </div>
  </div>
  <div class="mx-auto mt-8">
    <EventComponent
      :image-left="false"
      button-text="Sprawdź ofertę"
      video-src="/dla-firm/movie-1"
      :scroll-to-main-content="scrollToMainContent"
    >
      <template #title>
        <span class="text-black">Eventy</span>
        <span class="text-red mx-2">firmowe</span>
        <span class="text-black"><br class="hidden xl:block">z adrenaliną</span>
      </template>
      <p>Postaw na wieloletnie doświadczenie Go-Racing w organizacji wydarzeń, które zapewniają uczestnikom mocną dawkę adrenaliny i niezapomnianych wrażeń.</p>
      <p class="font-bold">
        Szukasz pomysłu na niezapomnianą imprezę integracyjną lub event firmowy?
      </p>
      <p>
        Zmotywuj, zaangażuj, zbuduj zgrany zespołu. Wzmocnij relacje            z pracownikami lub partnerami biznesowymi! Eventy motoryzacyjne organizujemy na terenie całego kraju.
      </p>
    </EventComponent>

    <EventComponent
      :image-left="true"
      button-text="Sprawdź ofertę"
      :scroll-to-main-content="scrollToMainContent"
      :gallery-images="[
        { url: '/dla-firm/galeria-1/pojazd-1.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-1/pojazd-2.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-1/pojazd-3.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-1/pojazd-4.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-1/pojazd-5.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-1/pojazd-6.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-1/pojazd-7.jpg', alt: 'sportowy samochód' },
      ]"
    >
      <template #title>
        <span class="text-black">Eventy z udziałem</span>
        <span class="text-red mx-2">supersamochodów</span>
      </template>
      <p>Realizujemy eventy motoryzacyjne dla firm z użyciem supersamochodów na wszystkich torach wyścigowych w Polsce.</p>
      <ul class="list-disc pl-5 font-semibold">
        <li>Lamborghini</li>
        <li>Ferrari</li>
        <li>Lotus</li>
        <li>Aston Martin</li>
        <li>KTM X-BOW</li>
        <li>Ariel Atom</li>
        <li>Formuła Renault 2.0</li>
        <li>samochody rajdowe i WRC</li>
      </ul>
    </EventComponent>

    <EventComponent
      :image-left="false"
      button-text="Sprawdź ofertę"
      :scroll-to-main-content="scrollToMainContent"
      :gallery-images="[
        { url: '/dla-firm/galeria-2/pojazd-1.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-2/pojazd-2.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-2/pojazd-3.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-2/pojazd-4.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-2/pojazd-5.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-2/pojazd-6.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-2/pojazd-7.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-2/pojazd-8.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-2/pojazd-9.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-2/pojazd-10.jpg', alt: 'sportowy samochód' },
      ]"
      custom-wrapper-class="bg-[#fdf8f9]"
    >
      <template #title>
        <span class="text-black">Eventy z udziałem</span>
        <span class="text-red mx-2">bolidów Formuły Renault 2.0</span>
      </template>
      <p>Jedyni w Polsce organizujemy eventy firmowe ze szkoleniem i jazdami bolidami Formuły Renault 2.0 na wszystkich torach w kraju.</p>
      <div class="text-14 lg:text-18 xl:text-20">
        <div v-for="item in renaultFormulaCar" :key="item.label" class="flex justify-between py-2">
          <span>{{ item.label }}:</span>
          <span class="text-red"><strong>{{ item.value }}</strong></span>
        </div>
      </div>
    </EventComponent>

    <EventComponent
      :image-left="true"
      button-text="Sprawdź ofertę"
      :scroll-to-main-content="scrollToMainContent"
      video-src="/dla-firm/movie-2"
    >
      <template #title>
        <span class="text-black">Imprezy</span>
        <span class="text-red mx-2">off-road dla firm</span>
      </template>
      <p>
        Organizujemy imprezy off-road dla firm w całej Polsce, m.in. jazda samochodami terenowymi lub quadami po bezdrożach, pokonywanie przeszkód, szkolenia off-road - doskonalenie techniki jazdy w różnych warunkach (błoto, piasek, kamienie), rajdy na orientację.
      </p>
      <p> Off-road to świetny sposób na dobrą zabawę i integrację oraz sprawdzenie umiejętności nawigacyjnych i pracy zespołowej.</p>
    </EventComponent>

    <EventComponent
      :image-left="false"
      button-text="Sprawdź ofertę"
      :scroll-to-main-content="scrollToMainContent"
      :gallery-images="[
        { url: '/dla-firm/galeria-3/pojazd-1.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-3/pojazd-2.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-3/pojazd-3.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-3/pojazd-4.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-3/pojazd-5.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-3/pojazd-6.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-3/pojazd-7.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-3/pojazd-8.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-3/pojazd-9.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-3/pojazd-10.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-3/pojazd-11.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-3/pojazd-12.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-3/pojazd-13.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-3/pojazd-14.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-3/pojazd-15.jpg', alt: 'sportowy samochód' },
      ]"
      custom-button-class="border-white text-white hover:text-red hover:bg-white"
      custom-wrapper-class="bg-[#343a40] text-white"
    >
      <template #title>
        <span class="text-white">Największy Off-Road Park w Polsce</span>
      </template>
      <p>Dysponujemy największym w Polsce Off-Road Parkiem w Górze Kalwarii, gdzie realizujemy imprezy firmowe, które stają się prawdziwą przygodą i epickim wspomnieniem.</p>
    </EventComponent>

    <EventComponent
      :image-left="true"
      button-text="Sprawdź ofertę"
      :scroll-to-main-content="scrollToMainContent"
      :gallery-images="[
        { url: '/dla-firm/galeria-4/pojazd-1.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-4/pojazd-2.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-4/pojazd-4.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-4/pojazd-5.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-4/pojazd-6.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-4/pojazd-7.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-4/pojazd-8.jpg', alt: 'sportowy samochód' },
        { url: '/dla-firm/galeria-4/pojazd-9.jpg', alt: 'sportowy samochód' },
      ]"
    >
      <template #title>
        <span class="text-black">Szkolenia</span>
        <span class="text-red mx-2">bezpiecznej jazdy</span>
      </template>
      <p>Szkolenia z bezpiecznej jazdy dla firm to doskonały sposób na podniesienie kwalifikacji kierowców, poprawę bezpieczeństwa na drodze i obniżenie kosztów związanych z eksploatacją floty pojazdów.</p>
      <div class="flex flex-wrap gap-2">
        <div
          v-for="(training, index) in defensiveDrivingTrainings"
          :key="index"
          class="text-red bg-[#fdf8f9] p-4"
        >
          {{ training }}
        </div>
      </div>
    </EventComponent>
  </div>
  <EventComponent
    :image-left="false"
    button-text="Sprawdź ofertę"
    :scroll-to-main-content="scrollToMainContent"
    image-src="/dla_firm_fill.png"
    image-alt="znak formuły 1"
    custom-wrapper-class="bg-red text-white relative overflow-hidden !m-0"
    custom-button-class="border-white text-white hover:text-red hover:bg-white"
    custom-image-class="hidden md:block absolute left-[45%] top-0 2xl:left-[65%] !w-auto"
  >
    <template #title>
      <span>Formula Drive - <br class="hidden xl:block"> Poprowadź bolid F1</span>
    </template>
    <p class="w-full md:w-1/2 lg:w-full">
      Jesteśmy organizatorem unikatowego wydarzenia: Formula Drive - Poprowadź bolid F1. To jedyna okazja w Polsce, aby samodzielnie poprowadzić bolid F1 Williams FW29 lub przejechać się jako pasażer w dwuosobowym bolidzie BMW Sauber F1.06 X2.
    </p>
  </EventComponent>

  <EventComponent
    :image-left="false"
    :show-button="false"
    video-src="/dla-firm/movie-3"
    custom-wrapper-class="bg-black text-white !m-0"
    :scroll-to-main-content="scrollToMainContent"
  >
    <template #title>
      <span>Mod Williams FW29</span>
    </template>
    <p>Williams FW29 to legendarny bolid Formuły 1, który umożliwia miłośnikom motorsportu spełnienie marzeń i przeżycie niezapomnianych emocji. Za kierownicą bolidów FW29 zasiadali tacy kierowcy jak Nico Rosberg, Alex Wurz i Kazuki Nakajima.</p>
    <div class="text-14 lg:text-18 xl:text-20">
      <div v-for="item in williamsFW29" :key="item.label" class="flex justify-between py-2">
        <span>{{ item.label }}:</span>
        <span><strong>{{ item.value }}</strong></span>
      </div>
    </div>
  </EventComponent>
  <div class="py-16 bg-[#fdf8f9]">
    <div class="w-11/12 2xl:w-2/3 mx-auto">
      <h2 class="text-24 leading-8 md:text-[30px] md:leading-10 xl:text-[36px] xl:leading-[44px] 2xl:text-[50px] 2xl:leading-[63px] font-bold text-center mb-4 xl:mb-8">
        Organizacja eventów <br class="hidden xl:block">firmowych z <span class="text-red">
          Go-Racing
        </span>
      </h2>
      <p class="text-center mb-4">
        Go-Racing – Profesjonaliści od motoryzacyjnych eventów firmowych!
      </p>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 xl:gap-8">
        <div v-for="section in sections" :key="section.title" class="flex items-start px-4 py-8">
          <div class="flex-none w-12 h-12 mr-4">
            <component :is="section.icon" class="w-12 h-12 bg-red p-2" />
          </div>
          <div class="flex flex-col justify-center">
            <h3 class="text-20 lg:text-24 font-bold lg:mt-[10px] mb-[10px] lg:mb-[20px] text-red">
              {{ section.title }}
            </h3>
            <p>{{ section.description }}</p>
          </div>
        </div>
      </div>
      <div class="text-center mt-8">
        <button class="border border-red bg-transparent hover:bg-red hover:text-white text-red font-bold transition-colors duration-200 px-8 py-4" @click="scrollToMainContent">
          Sprawdź ofertę
        </button>
      </div>
    </div>
  </div>

  <div class="w-11/12 mx-auto py-4 xl:py-16">
    <h2 class="text-24 leading-8 md:text-[30px] md:leading-10 xl:text-[36px] xl:leading-[44px] 2xl:text-[50px] 2xl:leading-[63px] font-bold text-center mb-4 xl:mb-16">
      Moc możliwości na <br class="hidden xl:block">eventach z <span class="text-red">Go-Racing</span>
    </h2>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 2xl:w-4/5 mx-auto">
      <div v-for="(box, index) in boxes" :key="index" class="relative text-center text-white p-4">
        <Img :src="box.src" :alt="box.alt" width="314" height="314" class="w-full h-auto" />
        <div class="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center p-4">
          <h3 class="font-bold mb-2 text-white text-24 px-8 lg:px-4 lg:text-18 2xl:text-24 2xl:px-8">
            {{ box.title }}
          </h3>
          <p class="px-8 lg:px-4 2xl:px-8 lg:text-12 2xl:text-14">
            {{ box.description }}
          </p>
        </div>
      </div>
    </div>
  </div>
  <div id="contact" class="w-11/12 mx-auto my-4 xl:my-16 flex flex-col xl:flex-row gap-4">
    <div class="bg-[#fdf8f9] w-full xl:w-1/2 flex flex-col p-4 lg:p-8">
      <h3 class="text-red text-24 leading-8 md:text-[30px] md:leading-10 xl:text-[36px] xl:leading-[44px] 2xl:text-[50px] 2xl:leading-[63px] mb-2 lg:mb-4 w-full">
        Zamów wycenę już dziś!
      </h3>
      <p class="2xl:text-16">
        Skontaktuj się z nami i zamów bezpłatną wycenę imprezy firmowej. Dostosujemy program eventu do Twoich indywidualnych potrzeb i budżetu.
      </p>
      <FormKit
        type="form"
        id="contact-form"
        :value="initialState"
        #default="{ value, disabled, state: { dirty, loading } }"
        :actions="false"
        :incomplete-message="false"
        @submit-raw="submitted = false"
        @submit="submit"
      >
        <div class="flex gap-[15px]">
          <FormKit
            type="email"
            outer-class="w-full mb-[10px]"
            name="email"
            autocomplete="email"
            label="E-mail*"
            placeholder="E-mail*"
            validation="required|email"
            validation-visibility="blur"
            :validation-messages="{
              required: 'Pole e-mail nie może być puste.',
              email: 'Błędny adres e-mail.'
            }"
          />

          <FormKit
            type="text"
            name="phone"
            label="Numer telefonu"
            placeholder="Numer telefonu"
            autocomplete="phone"
            outer-class="w-full mb-[10px]"
          />
        </div>

        <FormKit
          type="textarea"
          name="comment"
          label="Treść wiadomości*"
          placeholder="Treść wiadomości*"
          autocomplete="off"
          outer-class="mb-[10px] md:row-start-1 md:row-span-3 md:col-start-2"
          rows="8"
          :help="`${value?.comment ? value?.comment.length : 0} / 300`"
          validation="required|length:10,300"
          validation-visibility="blur"
          :validation-messages="{
            required: 'Pole wiadomość nie może być puste.',
            length: 'Pole wiadomość może zawierać od 10 do 300 znaków.'
          }"
        />
        <div>
          <FormKit
            type="checkbox"
            outer-class="mb-[10px]"
            name="rules"
            validation="accepted"
            validation-visibility="blur"
            :validation-messages="{
              accepted: 'Zaakceptuj regulamin.'
            }"
          >
            <template #suffix>
              <div>
                Wyrażam zgodę na przetwarzanie moich danych osobowych podanych w formularzu przez EMOTIVO sp. z o. o. w Puławach (24-100), ul. 6 Sierpnia 1, w sposób opisany w
                <NuxtLink to="/i/polityka-prywatnosci" target="_blank" class="underline">polityce prywatności</NuxtLink>
                w celu uzyskania odpowiedzi na pytanie, skontaktowania się na wskazane dane do korespondencji - zgodnie ze złożonym zapytaniem. Zgoda jest dobrowolna i może być w każdej chwili wycofana, kierując wiadomość na adres e-mail administratora. Wycofanie zgody nie wpływa na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem.*
              </div>
            </template>
          </FormKit>

          <div class="text-gray-500 text-12">
            * Pole wymagane
          </div>

          <div v-if="submitted && !dirty" class="flex bg-green items-center gap-[20px] text-white px-[20px] py-[10px] mt-[10px]">
            <Check class="shrink-0" />
            Wiadomość została wysłana.
          </div>

          <FormKit
            type="submit"
            :disabled="disabled"
            input-class="btn btn-action disabled:pointer-events-none disabled:bg-action-disabled mt-[5px]"
          >
            Wyślij <i class="icon-arrow-button text-10 ml-[5px]" />
            <LoadingIndicator v-if="loading" class="text-white h-[16px] w-[16px] ml-[5px] absolute" />
          </FormKit>
        </div>
      </FormKit>
      <div class="flex flex-col sm:flex-row justify-between items-center mt-4 lg:mt-8 w-full">
        <a href="tel:+48570310310" class="inline-flex items-center p-[5px] text-red">
          <i class="icon-phone w-[40px] text-[24px]" />
          <span class="font-bold lg:text-24 ml-2">570 310 310</span>
        </a>
        <a href="mailto:event@go-racing.pl" class="inline-flex items-center p-[5px] text-red">
          <i class="icon-mail w-[40px] text-[24px]" />
          <span class="font-bold lg:text-24 ml-2">event@go-racing.pl</span>
        </a>
      </div>
    </div>
    <div class="w-full xl:w-1/2 h-auto 2xl:max-h-[815px]">
      <Img src="/dla_firm-img-8.jpg" alt="Bolid Formuły Renault" width="600" height="700" class="w-full h-full object-cover" />
    </div>
  </div>
  <div class="flex flex-wrap lg:flex-nowrap mt-8 w-11/12 mx-auto gap-4 xl:gap-8 h-auto">
    <div v-for="(item, index) in eventTopics" :key="index" class="text-red bg-[#fdf8f9] py-4 lg:py-8 w-full text-center flex items-center justify-center">
      <p>
        {{ item }}
      </p>
    </div>
  </div>
</template>
